import React, {lazy, Suspense} from 'react'
import t from 'format-message'
import {useParams} from 'react-router'
import {useDocumentTitle} from '../common/lib/useDocumentTitle'

const Settings = lazy(() =>
  import('./components/pages/Settings').then(({Settings}) => ({default: Settings})),
)

export function SettingsPage() {
  const {activeAssignmentId} = useParams()

  useDocumentTitle(t('Settings'))

  return (
    <Suspense>
      <Settings activeAssignmentId={activeAssignmentId} />
    </Suspense>
  )
}

/**
 * @type {import('react-router').RouteObject[]}
 * @description The routes for the settings module.
 */
export const settingsRoutes = [
  {
    index: true,
    element: <SettingsPage />,
  },
]
